import { render, staticRenderFns } from "./session-expired.vue?vue&type=template&id=c0070452&scoped=true"
import script from "./session-expired.vue?vue&type=script&lang=js"
export * from "./session-expired.vue?vue&type=script&lang=js"
import style0 from "./session-expired.vue?vue&type=style&index=0&id=c0070452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0070452",
  null
  
)

export default component.exports